import AvenirNextBoldEOT from "../assets/fonts/AvriNextFont/avenir-next-bold.eot";
import AvenirNextBoldTTF from "../assets/fonts/AvriNextFont/avenir-next-bold.ttf";
import AvenirNextBoldWOFF from "../assets/fonts/AvriNextFont/avenir-next-bold.woff";
import AvenirNextRegularEOT from "../assets/fonts/AvriNextFont/avenir-next-regular.eot";
import AvenirNextRegularTTF from "../assets/fonts/AvriNextFont/avenir-next-regular.ttf";
import AvenirNextRegularWOFF from "../assets/fonts/AvriNextFont/avenir-next-regular.woff";
import AvenirNextThinEOT from "../assets/fonts/AvriNextFont/avenir-next-thin.eot";
import AvenirNextThinTTF from "../assets/fonts/AvriNextFont/avenir-next-thin.ttf";
import AvenirNextThinWOFF from "../assets/fonts/AvriNextFont/avenir-next-thin.woff";
import AvenirNextMediumEOT from "../assets/fonts/AvriNextFont/AvenirLTPro-Medium.eot";
import AvenirNextMediumTTF from "../assets/fonts/AvriNextFont/AvenirLTPro-Medium.ttf";
import AvenirNextMediumWOFF from "../assets/fonts/AvriNextFont/AvenirLTPro-Medium.woff";
import FullLogo from "../assets/images/group-3@3x.png";
import WebLogo from "../assets/images/earth.png";
import EmailLogo from "../assets/images/mail-big.png";
import PhoneLogo from "../assets/images/phone.png";

  export function generateHTMLCode (
    arrLength,
    month,
    year,
    doctorName,
    abn,
    streetNumber,
    streetName,
    suburb,
    state,
    postCode,
    doctorEmail,
    tableRows,
    totalAmount,
    totalFee,
    PMFee,
    GST,
    totalEarning,
    supportEmail,
    supportPhone
  ) {
    let paymentSlip = "";
    paymentSlip += "";
    paymentSlip += "<!DOCTYPE html>";
    paymentSlip += '<html lang="en">';
    paymentSlip += "<head>";
    paymentSlip += "        <title>Payment Summary Slip</title>";
    paymentSlip += '            <meta charset="utf-8">';
    paymentSlip +=
      '            <meta name="viewport" content="width=device-width, initial-scale=1">';
    paymentSlip +=
      '            <link rel="stylesheet" href="https://maxcdn.bootstrapcdn.com/bootstrap/3.3.7/css/bootstrap.min.css">';
    paymentSlip +=
      '            <link rel="stylesheet" href="https://maxcdn.bootstrapcdn.com/font-awesome/4.7.0/css/font-awesome.min.css">';
    paymentSlip +=
      '            <script src="https://ajax.googleapis.com/ajax/libs/jquery/3.2.0/jquery.min.js"></script>';
    paymentSlip +=
      '            <script src="https://maxcdn.bootstrapcdn.com/bootstrap/3.3.7/js/bootstrap.min.js"></script>';
    paymentSlip += "            <style> body{padding:0px; margin:0px}";
    paymentSlip += "                @font-face {";
    paymentSlip += "        ";
    paymentSlip += "                    font-family: 'AvenirNextBold';";
    paymentSlip += "                    src: url('" + AvenirNextBoldEOT + "');";
    paymentSlip +=
      "                    src: url('" +
      AvenirNextBoldEOT +
      "') format('embedded-opentype'),";
    paymentSlip +=
      "                    url('" + AvenirNextBoldWOFF + "') format('woff'),";
    paymentSlip +=
      "                    url('" +
      AvenirNextBoldTTF +
      "') format('truetype');";
    paymentSlip += "                }";
    paymentSlip += "                @font-face {";
    paymentSlip += "                    font-family: 'AvenirNextRegular';";
    paymentSlip +=
      "                    src: url('" + AvenirNextRegularEOT + "');";
    paymentSlip +=
      "                    src: url('" +
      AvenirNextRegularEOT +
      "') format('embedded-opentype'),";
    paymentSlip +=
      "                    url('" +
      AvenirNextRegularWOFF +
      "') format('woff'),";
    paymentSlip +=
      "                    url('" +
      AvenirNextRegularTTF +
      "') format('truetype');";
    paymentSlip += "                }";
    paymentSlip += "                @font-face {";
    paymentSlip += "                    font-family: 'AvenirNextThin';";
    paymentSlip += "                    src: url('" + AvenirNextThinEOT + "');";
    paymentSlip +=
      "                    src: url('" +
      AvenirNextThinEOT +
      "') format('embedded-opentype'),";
    paymentSlip +=
      "                    url('" + AvenirNextThinWOFF + "') format('woff'),";
    paymentSlip +=
      "                    url('" +
      AvenirNextThinTTF +
      "') format('truetype');";
    paymentSlip += "                }";
    paymentSlip += "                @font-face {";
    paymentSlip += "                    font-family: 'AvenirNextMedium';";
    paymentSlip +=
      "                    src: url('" + AvenirNextMediumEOT + "');";
    paymentSlip +=
      "                    src: url('" +
      AvenirNextMediumEOT +
      "?#iefix') format('embedded-opentype'),";
    paymentSlip +=
      "                    url('" + AvenirNextMediumWOFF + "') format('woff'),";
    paymentSlip +=
      "                    url('" +
      AvenirNextMediumTTF +
      "') format('truetype');";
    paymentSlip += "                    font-weight: 500;";
    paymentSlip += "                    font-style: normal;";
    paymentSlip += "                }";
    paymentSlip += "                .class1 {";
    paymentSlip += "                    max-width: 100%;";
    paymentSlip += "                    width: 100%;";
    paymentSlip += "                    margin: 0 auto;";
    paymentSlip += "                    margin-top: 1%;";
    paymentSlip += "                    padding: 15px 30px;";
    paymentSlip += "                }";

    paymentSlip +=
      ".custom-tbl, .custom-tbl thead tr td, .custom-tbl tbody tr td, .custom-tbl tbody tr { border: 0}";

    paymentSlip += "            </style>";
    paymentSlip += "        </head>";
    paymentSlip += '        <body style="background-color: #f5f8f9;">';
    paymentSlip += '        <div class="container class1">';
    paymentSlip += '            <div class="row" >';
    paymentSlip +=
      '                <div class="col-sm-2 col-md-2 w-25 " style="text-align:left;padding:0px;overflow:hidden;">';
    paymentSlip +=
      '<img src="' +
      FullLogo +
      '" style="width:250px;height:auto;padding-bottom: 3px"  alt="logo"/>';
    // '
    // paymentSlip +=
    // '
    paymentSlip += "                </div>";
    paymentSlip +=
      '                <div class="col-sm-2 col-md-2 " style="text-align:right;padding:0px;">';
    paymentSlip +=
      '                    <div style="font-family:AvenirNextMedium; font-size:20px; color: black;font-weight: bold">';

    paymentSlip += "Payment Summary";

    paymentSlip += "                    </div>";
    paymentSlip +=
      '                    <div style="font-family:AvenirNextMedium; font-size:16px; color: black;padding-bottom: 20px">';

    paymentSlip += month + " " + year;

    paymentSlip += "                    </div>";
    paymentSlip += "                </div>";
    paymentSlip += "            </div>";
    paymentSlip += '            <div class="row">';
    paymentSlip += '                <div class="col-sm-2 col-md-2 "';
    paymentSlip +=
      '                     style="text-align:left;font-family:AvenirNextMedium; font-size:16px; font-weight: bold; top:16px; color: black;padding:0px;padding-top: 9px;padding-bottom: 0px">';
    paymentSlip += "                    Instant Consult";
    paymentSlip += "                </div>";
    paymentSlip += '                <div class="col-sm-2 col-md-2 "';
    paymentSlip +=
      '                     style="text-align:right;font-family:AvenirNextMedium; font-size:16px; color: black;padding:0px;padding-top: 16px;">';

    paymentSlip += "Dr. " + doctorName;

    paymentSlip += "                </div>";
    paymentSlip += "            </div>";
    paymentSlip += '            <div class="row">';
    paymentSlip += '                <div class="col-sm-2 col-md-2 "';
    paymentSlip +=
      '                     style="text-align:left;font-family: AvenirNextRegular;top:14px; font-size:16px;color: black;padding-bottom:0px;padding:0px">';
    paymentSlip += "                    ACN: 617 811 337";
    paymentSlip += "                </div>";
    paymentSlip += '                <div class="col-sm-2 col-md-2 "';
    paymentSlip +=
      '                     style="text-align:right;font-family: AvenirNextRegular; font-size:16px;color: black;padding-bottom:3px;padding:0px">';

    paymentSlip +=
      "ABN: " + (abn.length ? abn.substring(0, 2) +
      " " +
      abn.substring(2, 5) +
      " " +
      abn.substring(5, 8) +
      " " +
      abn.substring(8, 11) : '-');
      // abn.substring(0, 2) +
      // " " +
      // abn.substring(2, 5) +
      // " " +
      // abn.substring(5, 8) +
      // " " +
      // abn.substring(8, 11);

    paymentSlip += "                </div>";
    paymentSlip += "            </div>";
    paymentSlip += '            <div class="row">';
    paymentSlip += '                <div class="col-sm-2 col-md-2 "';
    paymentSlip +=
      '                     style="text-align:left;font-family: AvenirNextRegular; font-size:16px;color: black;top:15px;padding-top:5px; padding-left:0px">';
    paymentSlip +=
      '<img src="' +
      PhoneLogo +
      '" alt="web-log" style="width: 15px; height:15px; margin-right: 3px"" />&nbsp;&nbsp;&nbsp;' +
      supportPhone;
    // '                    <i class="fas fa-phone-alt" style="color:black !important;" aria-hidden="true"></i>&nbsp;&nbsp;&nbsp;' + supportPhone;
    paymentSlip += "                </div>";
    paymentSlip += '                <div class="col-sm-2 col-md-2 "';
    paymentSlip +=
      '                     style="text-align:right;font-family:AvenirNextRegular; font-size:16px; color: black;padding:0px;text-transform: capitalize;">';

    paymentSlip +=
      streetNumber +
      " " +
      streetName +
      " <br/>" +
      suburb +
      " " +
      state +
      " " +
      postCode;

    paymentSlip += "                </div>";
    paymentSlip += "            </div>";
    paymentSlip += '            <div class="row">';
    paymentSlip += '                <div class="col-sm-2 col-md-2 "';
    paymentSlip +=
      '                     style="position:relative;text-align:left;font-family: AvenirNextRegular; font-size:16px;color: black;padding:0px">';
    paymentSlip +=
      '<img src="' +
      EmailLogo +
      '" alt="web-log" style="width: 15px; height:15px; margin-right: 3px"" />';
    // '                    <i class="fa fa-envelope" style="color:black !important; margin-right: 3px" aria-hidden="true"></i>&nbsp;';
    paymentSlip +=
      "&nbsp;&nbsp;&nbsp;<span style='position: absolute; top:0; left: 33px;'>" +
      supportEmail;
    paymentSlip += "                </span></div>";
    paymentSlip += '                <div class="col-sm-2 col-md-2 "';
    paymentSlip +=
      '                     style="text-align:right;font-family:AvenirNextMedium;font-size:16px;color: rgb(245,171,53) !important;padding:0px;padding-top:3px;">';

    paymentSlip += doctorEmail;

    paymentSlip += "                </div>";
    paymentSlip += "            </div>";
    paymentSlip += '            <div class="row">';
    paymentSlip +=
      '                <div class="col-sm-12 col-lg-12 col-xs-12 col-md-12 "';
    paymentSlip +=
      '                     style="text-align:left;font-family: AvenirNextRegular; font-size:16px;color: black;padding:0px">';
    paymentSlip +=
      '<img src="' +
      WebLogo +
      '" alt="web-log" style="width: 15px; height:15px; margin-right: 3px"" /> &nbsp;&nbsp;&nbsp;instantconsult.com.au';
    // '                    <i class="fa fa-globe" style="color:black !important;" aria-hidden="true"></i>&nbsp;&nbsp;&nbsp;instantconsult.com.au';
    paymentSlip += "                </div>";
    paymentSlip += "            </div>";
    paymentSlip += '            <div class="row" style="padding-top:15px;">';
    paymentSlip += '                <div class="col-sm-2 col-md-2 "';
    paymentSlip +=
      '                     style="text-align:left;font-family:AvenirNextMedium;font-size: 16px;color:black; padding-bottom:5px;padding:0px">';

    paymentSlip +=
      "                    Consultation Cost - " + month + " " + year;

    paymentSlip += "                </div>";

    paymentSlip += '                <div class="col-sm-2 col-md-2 rightRow"';
    paymentSlip +=
      '                     style="text-align:right;font-family:AvenirNextMedium;font-size: 16px;color: black;padding:0px">';

    // paymentSlip += '$' + (totalAmount).toLocaleString(undefined, {maximumFractionDigits:2});
    paymentSlip += new Intl.NumberFormat("au-AU", {
      style: "currency",
      currency: "AUD"
    })
      .format(totalAmount)
      .slice(1);

    paymentSlip += "                </div>";
    paymentSlip += "            </div>";

    paymentSlip += '            <div class="row" style="padding-top:5px">';
    paymentSlip += '                <div class="col-sm-2 col-md-2"';
    paymentSlip +=
      '                     style="background-color: rgb(245,245,245) !important;text-align: left;font-family:AvenirNextMedium;letter-spacing:0.1px;font-size: 16px;font-weight:500;color: black;padding:0px">';
    paymentSlip += "                    Total Fee";
    paymentSlip += "                </div>";
    paymentSlip += '                <div class="col-sm-2 col-md-2"';
    paymentSlip +=
      '                     style="background-color:rgb(245,245,245) !important;text-align:right;font-family: AvenirNextMedium;font-size: 16px;font-weight:500;color: black;padding:0px">';

    // paymentSlip += '$' + (totalFee).toLocaleString(undefined, {maximumFractionDigits:2});
    paymentSlip += new Intl.NumberFormat("au-AU", {
      style: "currency",
      currency: "AUD"
    })
      .format(totalFee)
      .slice(1);

    paymentSlip += "                </div>";
    paymentSlip += "            </div>";
    paymentSlip += '            <div class="row" style="padding-top:5px">';
    paymentSlip += '                <div class="col-sm-2 col-md-2 "';
    paymentSlip +=
      '                     style="text-align:left;font-family:AvenirNextMedium;font-size: 16px;color: black;padding:0px">';
    paymentSlip += "                    Practice Management Fee";
    paymentSlip += "                </div>";
    paymentSlip += '                <div class="col-sm-2 col-md-2 "';
    paymentSlip +=
      '                     style="text-align:right;font-family:AvenirNextMedium;font-size: 16px;color: black;padding:0px">';

    // paymentSlip += '$' + (PMFee).toLocaleString(undefined, {maximumFractionDigits:2});
    paymentSlip += new Intl.NumberFormat("au-AU", {
      style: "currency",
      currency: "AUD"
    })
      .format(PMFee)
      .slice(1);

    paymentSlip += "                </div>";
    paymentSlip += "            </div>";
    paymentSlip += '            <div class="row" style="padding-top:5px">';
    paymentSlip += '                <div class="col-sm-2 col-md-2 "';
    paymentSlip +=
      '                     style="text-align:left;font-family:AvenirNextMedium;font-size: 16px;color: black;padding:0px">';
    paymentSlip += "                    GST on Practice Management Fee";
    paymentSlip += "                </div>";
    paymentSlip += '                <div class="col-sm-2 col-md-2 "';
    paymentSlip +=
      '                     style="text-align:right;font-family:AvenirNextMedium;font-size: 16px;color: black;padding:0px">';

    // paymentSlip += '$' + (GST).toLocaleString(undefined, {maximumFractionDigits:2});
    paymentSlip += new Intl.NumberFormat("au-AU", {
      style: "currency",
      currency: "AUD"
    })
      .format(GST)
      .slice(1);

    paymentSlip += "                </div>";
    paymentSlip += "            </div>";
    paymentSlip += '            <div class="row" style="padding-top:5px;">';
    paymentSlip += '                <div class="col-sm-2 col-md-2"';
    paymentSlip +=
      '                     style="background-color: rgb(245,245,245) !important;text-align:left;font-family:AvenirNextMedium;font-size: 18px;font-weight: bold;color: black;padding:0px">';
    paymentSlip += "                    Total Earnings";
    paymentSlip += "                </div>";
    paymentSlip += '                <div class="col-sm-2 col-md-2 rightRow"';
    paymentSlip +=
      '                     style="background-color: rgb(245,245,245) !important;text-align:right;font-family:AvenirNextMedium;font-size: 18px;font-weight: bold;color: black;padding:0px">';

    // paymentSlip += '$' + (totalEarning).toLocaleString(undefined, {maximumFractionDigits:2});
    paymentSlip += new Intl.NumberFormat("au-AU", {
      style: "currency",
      currency: "AUD"
    })
      .format(totalEarning)
      .slice(1);

    paymentSlip += "                </div>";
    paymentSlip += "            </div>";
    paymentSlip += "        </div>";
    paymentSlip += "        </body>";
    paymentSlip += "        </html>";

    return paymentSlip;
  };
